import { DynamicValue } from "@faedev/dynamic-values";
import { composeClassNames } from "@faedev/editor-utils";
import { useState } from "react";
import { Button } from "react-bootstrap";
import FiltersSelector from "src/components/FilterSelector";
import Translate from "src/components/Translate";
import Small_chevron_down from "src/icons/Small-chevron-down";
import Small_chevron_up from "src/icons/Small-chevron-up";
import { sButton } from "src/styles/sButton.module.scss";
import { filtersSection } from "src/styles/sFiltersSection.module.scss";

type Props<T> = {
  set: DynamicValue<Set<string>>;
  all: ReadonlyArray<T>;
  recommended?: ReadonlyArray<T>;
};

type ReadableName = { value: string; title: string };

export default function FiltersSet<T extends string | ReadableName>({
  set,
  all,
  recommended,
}: Props<T>) {
  const [showAll, setShowAll] = useState(false);
  const shownItems = showAll
    ? typeof all === "object" && all.length === undefined
      ? Object.keys(all)
      : all
    : recommended ||
      (typeof all === "object" && all.length === undefined
        ? Object.keys(all)
        : all);

  const shownItemsValues = Object.values(all);

  return (
    <div className={composeClassNames([filtersSection])}>
      {shownItems.map((item, i) => {
        if (item === "null") return;
        const itemKey = typeof item === "string" ? item : item.value;
        return (
          <FiltersSelector
            key={i}
            onClick={() => {
              const copySet = new Set(set.value);

              if (set.value.has(itemKey)) {
                copySet.delete(itemKey);
              } else {
                copySet.add(itemKey);
              }
              set.change(copySet);
            }}
            enabled={set.value.has(itemKey)}
            title={
              typeof item === "string" ? (
                <Translate tKey={item}></Translate>
              ) : (
                item.title
              )
            }
            values={(!recommended || showAll) && shownItemsValues[i]}
          />
        );
      })}
      {recommended ? (
        <Button
          variant="link"
          onClick={() => setShowAll(!showAll)}
          className={composeClassNames([sButton, "btn-icon-after", "show-all"])}
          size="sm"
        >
          {showAll ? (
            <Translate tKey="Show less" />
          ) : (
            <Translate tKey="Show all" />
          )}
          {showAll ? (
            <Small_chevron_up />
          ) : (
            <Small_chevron_down
              className={composeClassNames(["rotate-down"])}
            />
          )}
        </Button>
      ) : null}
    </div>
  );
}
